import UpdatePromoCodeRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/PromoCodeService/UpdatePromoCodeRequest";
import PromoCodeGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/PromoCodeService/PromoCodeGetDetailResponse";

export default class CreatePromocodeViewModel {
    id?: number = null;
	code: string = '';
	premiumDays: number = null;
	isSingleUse: boolean = false;
	expirationDate: Date = new Date();
	toServerModel(): UpdatePromoCodeRequest {
		const req = new UpdatePromoCodeRequest({
			Id: this.id,
			Code: this.code,
			PremiumDays: this.premiumDays,
			ExpirationDate: this.expirationDate,
			IsSingleUse: this.isSingleUse
		});
		return req;
	}
	fromServerModel(model: PromoCodeGetDetailResponse) {
		this.id = model.Id;
		this.code = model.Code;
		this.premiumDays = model.PremiumDays;
		this.isSingleUse = model.IsSingleUse;
		this.expirationDate = new Date(model.ExpirationDate);
	}
}
